import { cx, styled } from "simplydo/react/styled";

import type { PlaceholderLineProps } from "./Placeholder.types";

const LENGTH_WIDTH: Record<string, string> = {
  full: "100%",
  long: "75%",
  medium: "50%",
  short: "25%",
};

const Line = styled.div<{ $width: string }>`
  height: 0.8em;
  margin: 0.4em 0;
  background: rgba(0, 0, 0, 0.06);
  border-radius: 0.2em;
  width: ${({ $width }) => $width};
`;

const PlaceholderLineComponent = (props: PlaceholderLineProps) => {
  const { length, className, style } = props;
  return (
    <Line
      className={cx(className)}
      style={style}
      $width={(length && LENGTH_WIDTH[length]) || "100%"}
    />
  );
};

export const PlaceholderLine = styled(PlaceholderLineComponent)``;
